import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  USER_DETAIL,
  USER_DETAIL_SUCCESS,
  USER_DETAIL_ERROR,
  CLIENT_DETAIL,
  CLIENT_DETAIL_SUCCESS,
  CLIENT_DETAIL_ERROR,
  CLIENT_DETAILS,
  CLIENT_DETAILS_SUCCESS,
  CLIENT_DETAILS_ERROR,
} from "./actionTypes"

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  }
}


export const getUserDetail = (agentId, clientId) => ({
  type: USER_DETAIL,
  agentId,
  clientId,
})

export const getUserDetailSuccess = userdetail => ({
  type: USER_DETAIL_SUCCESS,
  payload: userdetail,
})

export const getUserDetailFail = error => ({
  type: USER_DETAIL_ERROR,
  payload: error,
})



export const getClientDetails = (clientId) => ({
  type: CLIENT_DETAILS,
  clientId
})

export const getClientDetailsSuccess = clientDetails => ({
  type: CLIENT_DETAILS_SUCCESS,
  payload: clientDetails,
})

export const getClientDetailsFail = error => ({
  type: CLIENT_DETAILS_ERROR,
  payload: error,
})